const DefaultRequestConst = {
    asc: false,
    limit: 250,
    page: 0,
    search:'',
    sort: 'date',
};

export default DefaultRequestConst;